"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFilterOption = void 0;
const mobx_1 = require("mobx");
const vocabularies_1 = require("../../vocabularies");
const metaDataHelpers_1 = require("../../helpers/metaDataHelpers");
class SortFilterOption {
    constructor() {
        this.sortBy = vocabularies_1.SortFilterOptions.A_Z;
        this.setSortBy = (sortBy) => {
            this.sortBy = sortBy;
        };
        this.reset = () => {
            this.sortBy = vocabularies_1.SortFilterOptions.A_Z;
        };
        this.sortFromAToZ = (listing) => {
            return listing.sort((a, b) => {
                const aName = a.parentProductName
                    ? `${a.parentProductName} ${a.name}`.toLowerCase()
                    : a.name.toLowerCase();
                const bName = b.parentProductName
                    ? `${b.parentProductName} ${b.name}`.toLowerCase()
                    : b.name.toLowerCase();
                return aName.toLowerCase().localeCompare(bName.toLowerCase());
            });
        };
        this.sortFromZToA = (listing) => {
            return listing.sort((a, b) => {
                const aName = a.parentProductName
                    ? `${a.parentProductName} ${a.name}`.toLowerCase()
                    : a.name.toLowerCase();
                const bName = b.parentProductName
                    ? `${b.parentProductName} ${b.name}`.toLowerCase()
                    : b.name.toLowerCase();
                return bName.toLowerCase().localeCompare(aName.toLowerCase());
            });
        };
        this.sortByPriceHighToLow = (listing) => {
            return listing.sort((a, b) => {
                if (a.price === null)
                    return 1;
                if (b.price === null)
                    return -1;
                return b.price - a.price;
            });
        };
        this.sortByPriceLowToHigh = (listing) => {
            return listing.sort((a, b) => {
                if (a.price === null)
                    return 1;
                if (b.price === null)
                    return -1;
                return a.price - b.price;
            });
        };
        this.sortByTHCHighToLow = (listing) => {
            return listing.sort((a, b) => {
                const aTHC = (0, metaDataHelpers_1.getTHCValueFromMetaData)(a.metaData, 'max');
                const bTHC = (0, metaDataHelpers_1.getTHCValueFromMetaData)(b.metaData, 'max');
                if (aTHC === null)
                    return 1;
                if (bTHC === null)
                    return -1;
                return bTHC - aTHC;
            });
        };
        this.sortByTHCLowToHigh = (listing) => {
            return listing.sort((a, b) => {
                const aTHC = (0, metaDataHelpers_1.getTHCValueFromMetaData)(a.metaData, 'min');
                const bTHC = (0, metaDataHelpers_1.getTHCValueFromMetaData)(b.metaData, 'min');
                if (aTHC === null)
                    return 1;
                if (bTHC === null)
                    return -1;
                return aTHC - bTHC;
            });
        };
        this.sortByCBDHighToLow = (listing) => {
            return listing.sort((a, b) => {
                const aCBD = (0, metaDataHelpers_1.getCBDValueFromMetaData)(a.metaData, 'max');
                const bCBD = (0, metaDataHelpers_1.getCBDValueFromMetaData)(b.metaData, 'max');
                if (aCBD === null)
                    return 1;
                if (bCBD === null)
                    return -1;
                return bCBD - aCBD;
            });
        };
        this.sortByCBDLowToHigh = (listing) => {
            return listing.sort((a, b) => {
                const aCBD = (0, metaDataHelpers_1.getCBDValueFromMetaData)(a.metaData, 'min');
                const bCBD = (0, metaDataHelpers_1.getCBDValueFromMetaData)(b.metaData, 'min');
                if (aCBD === null)
                    return 1;
                if (bCBD === null)
                    return -1;
                return aCBD - bCBD;
            });
        };
        this.filter = (listing) => {
            switch (this.sortBy) {
                case vocabularies_1.SortFilterOptions.A_Z:
                    return this.sortFromAToZ(listing);
                case vocabularies_1.SortFilterOptions.Z_A:
                    return this.sortFromZToA(listing);
                case vocabularies_1.SortFilterOptions.PRICE_HIGH_LOW:
                    return this.sortByPriceHighToLow(listing);
                case vocabularies_1.SortFilterOptions.PRICE_LOW_HIGH:
                    return this.sortByPriceLowToHigh(listing);
                case vocabularies_1.SortFilterOptions.THC_HIGH_LOW:
                    return this.sortByTHCHighToLow(listing);
                case vocabularies_1.SortFilterOptions.THC_LOW_HIGH:
                    return this.sortByTHCLowToHigh(listing);
                case vocabularies_1.SortFilterOptions.CBD_HIGH_LOW:
                    return this.sortByCBDHighToLow(listing);
                case vocabularies_1.SortFilterOptions.CBD_LOW_HIGH:
                    return this.sortByCBDLowToHigh(listing);
                default:
                    return listing;
            }
        };
    }
    get isSet() {
        return this.sortBy !== vocabularies_1.SortFilterOptions.A_Z;
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", String)
], SortFilterOption.prototype, "sortBy", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], SortFilterOption.prototype, "setSortBy", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], SortFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SortFilterOption.prototype, "isSet", null);
exports.SortFilterOption = SortFilterOption;
//# sourceMappingURL=SortFilterOption.js.map